import axios from 'axios'
import Config from '../assets/config'
import { eventHub } from '../utils/eventhub'
import * as AppStorage from "../storage/appstorage";

let token = AppStorage.get('token')

let client = axios.create({
    baseURL: Config.API.url,
    headers: { 'Authorization': 'Bearer ' + token }
});

client.interceptors.request.use(
    conf => {
        eventHub.$emit('before-request');
        return conf;
    },
    error => {
        eventHub.$emit('request-error');
        return Promise.reject(error);
    }
);
client.interceptors.response.use(
    response => {
        eventHub.$emit('after-response');
        return response;
    },
    error => {
        eventHub.$emit('response-error');
        return Promise.reject(error);
    }
);

export default client;
